import f from "./design-system.es126.js";
import { confirmDialogKey as l } from "./design-system.es20.js";
const a = () => {
  const o = f();
  return {
    emitter: o,
    open: (r = {}) => {
      const e = () => {
        o.off("cancel"), o.off("confirm");
      };
      o.emit("open", r);
      const { onConfirm: i, onCancel: t } = r;
      return i ? (o.on("cancel", () => {
        t && t(), e();
      }), o.on("confirm", () => {
        i(), e();
      }), new Promise(() => {
      })) : new Promise((c, m) => {
        o.on("cancel", () => {
          m(), e();
        }), o.on("confirm", () => {
          c(), e();
        });
      });
    }
  };
}, p = () => {
  const o = a();
  return o.install = (n) => {
    n.config.globalProperties.$confirmDialogEmitter = o.emitter, n.config.globalProperties.$confirm = o.open, n.provide(l, o);
  }, o;
};
export {
  a as createConfirmDialog,
  p as createConfirmDialogGlobal
};
//# sourceMappingURL=design-system.es13.js.map
